// prettier-ignore
export const isDev = process.env["STAGE"]?.toLowerCase()
  .startsWith('dev') ?? false
// prettier-ignore
export const isProd = process.env["STAGE"]?.toLowerCase()
  .startsWith('prod') ?? false
export const bslOrgId = "2ba60ce5-70da-4338-95bf-dc61d9817fe1"
export const bslVertriebUserId = "59392436-89ca-498c-837e-6962fd2ff92b"
export const RUNS_ON_AWS = !!process.env["AWS_DEFAULT_REGION"]
